import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { KeyRound, LogIn, Store, Megaphone, Bot, Mail, HelpCircle } from "lucide-react";

const SUPPORT_EMAIL = "support@velopaths.com";

// Lightweight public help shown to unauthenticated users ("Need help? Ask Velo").
export function HelpDialog({ open, onOpenChange, onForgotPassword }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="help-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Bot className="w-5 h-5 text-primary" />Ask Velo — Help</DialogTitle>
          <DialogDescription>Quick answers to the most common sign-in and account questions.</DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="rounded-xl border border-border bg-card p-3">
            <div className="flex items-center gap-2 font-semibold text-sm"><LogIn className="w-4 h-4 text-primary" />Trouble signing in?</div>
            <p className="text-sm text-muted-foreground mt-1">Double-check your email and password. Partner accounts can only sign in once Velopaths has approved the shop and the one-time setup fee is paid.</p>
          </div>

          <div className="rounded-xl border border-border bg-card p-3">
            <div className="flex items-center gap-2 font-semibold text-sm"><KeyRound className="w-4 h-4 text-primary" />Forgot your password?</div>
            <p className="text-sm text-muted-foreground mt-1">Reset it by email in a few seconds.</p>
            <Button size="sm" variant="outline" className="mt-2" data-testid="help-reset-password" onClick={() => { onOpenChange(false); onForgotPassword?.(); }}>Reset my password</Button>
          </div>

          <div className="rounded-xl border border-border bg-card p-3">
            <div className="flex items-center gap-2 font-semibold text-sm"><Store className="w-4 h-4 text-primary" />New here? Onboarding</div>
            <div className="text-sm text-muted-foreground mt-1 space-y-1">
              <div className="flex items-center gap-1.5"><Store className="w-3.5 h-3.5" />Bike rental shop? <Link to="/signup/shop" className="text-primary hover:underline" onClick={() => onOpenChange(false)} data-testid="help-onboard-shop">Onboard here</Link></div>
              <div className="flex items-center gap-1.5"><Megaphone className="w-3.5 h-3.5" />Business advertiser? <Link to="/signup/advertiser" className="text-primary hover:underline" onClick={() => onOpenChange(false)} data-testid="help-onboard-advertiser">Sign up</Link></div>
            </div>
          </div>

          <div className="rounded-xl border border-border bg-card p-3">
            <div className="flex items-center gap-2 font-semibold text-sm"><HelpCircle className="w-4 h-4 text-primary" />About Velopaths</div>
            <p className="text-sm text-muted-foreground mt-1">Velopaths helps bike-path partners and advertisers reach riders with curated routes, attractions and sponsored stops along the trail.</p>
          </div>

          <div className="flex items-center justify-between pt-1 border-t border-border">
            <span className="text-sm text-muted-foreground">Need additional help?</span>
            <a href={`mailto:${SUPPORT_EMAIL}`} className="text-sm text-primary hover:underline flex items-center gap-1.5" data-testid="help-contact-support"><Mail className="w-4 h-4" />Contact Support</a>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
